import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

import { BlockTextType } from '../../models/Content';

export const BlockWrapper = styled.div<{ $colorOption?: BlockTextType['fields']['colorOption'] }>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    background-color: ${({ $colorOption }) =>
        $colorOption === 'color-light-grey'
            ? getPurpurColor('backgroundSecondary')
            : getPurpurColor('backgroundPrimary')};
    padding: ${getPurpurSpacing('600')} 0;

    ${purpurMedia('md')`
        padding: ${getPurpurSpacing('800')} 0;
    `}
`;
